import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import exportAllIcon from './../../../assets/img/mm/download-solid-full.svg';
import download from 'downloadjs';
class ExportAll extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            userInfo: getLoginDistrictInfo(),
        }
    }

    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
   
    getExportAll = () => {
       const districtID = this.state.userInfo.districtId;
       const verificationYear = this.props.selectedSchoolYear;
       const schoolId = this.props.selectedSchoolId;
       this.setState({ loading: true });
       const schoolParam = schoolId ? `schoolId=${schoolId}&` : '';
        get(`/verification/reports/exportAll/${districtID}/${verificationYear}?${schoolParam}access_token=`
          ) .then((response) => {
            if (!response.ok) {
                return response.json().then((errorResponse) => {
                    throw new Error(
                        errorResponse.statusMessage ||
                        errorResponse.errorMessage ||
                        "No data found."
                    );
                });
            }
            return response.blob();
        })
        .then((blob) => {
            // ZIP file should be downloaded, not opened
            download(
                blob,
                `ExportAllReports_${verificationYear}.zip`,
                "application/zip"
            );
            this.setState({ loading: false });
        })
        .catch((error) => {
            console.log("getExportAll error:", error);
            const msg =
                typeof error === "string"
                    ? error
                    : error.message || "No data found.";
            _addNotificationError(msg, this.props);
            this.setState({ loading: false });
        });
    };
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget" style={{ minHeight: '100px' }}>
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={exportAllIcon} style={{ width: '40px', height: '40px' }} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Export All Reports(ZIP)</b></span>
                                    <p>Every 2026-2027 report(district wide)</p>
                                </div>
                            </div>
                            <div className='reportCard-widget-meeting-action' style={{
                                                                                    marginLeft: 'auto',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center' }}>
                                    <button type='button' className="btn btn-success btn-sm" style={{ margin: '0px' }} onClick={() => {
                                        this.getExportAll()
                                    }}><i className="fa fa-download"></i> Export All</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default ExportAll;


// WEBPACK FOOTER //
// ./src/components/District/VerificationReport/exportAll.js